import { useState } from 'react';
import { TICKETING_SERVICE_BASEURL } from '../../../config/browser';

const BASE_URL = `${TICKETING_SERVICE_BASEURL}/graphql?query=`;

interface SubmitResult {
  status: boolean;
  message: string;
}

export function useSubmitSFMCData() {
  // const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<SubmitResult | null>(null);
  const [error, setError] = useState<Error | null>(null);

  const submitData = async (email: string, userCountry: string) => {
    // setLoading(true);
    setError(null);

    try {
      const graphql = `
        {
          query: submitSFMCData(email:"${email}", userCountry: "${userCountry}") {
            message,
            status
          }
        }
      `;
      const url = encodeURI(`${BASE_URL}${graphql}`);
      const res = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const response = await res.json();
      setResult(response);
      return response;
    } catch (e) {
      const err = e instanceof Error ? e : new Error('Unknown error');
      setError(err);
      throw err;
    }
  };

  return { submissionData: submitData, resultData: result, submissionError: error };
}

/*import { useGet } from '../../../common/hooks/useGet';
import { TICKETING_SERVICE_BASEURL } from '../../../config/browser';

const BASE_URL = `${TICKETING_SERVICE_BASEURL}/graphql?query=`;

export const useSubmitData = (email: string, userCountry: string) => {
  const graphql = `
    {
      query: submitSFMCData(email:"${email}", userCountry: "${userCountry}") {
        message,
        status
      }
    }
  `;
  const url = encodeURI(`${BASE_URL}${graphql}`);
  //const { data, error } = useGet(url, { query: null }, false, false, 1);
  const { data, error, loading } = useGet(url, { query: null }, false, false, 1);

  return { error, data, loading: !!url && loading };
};*/
